export default "__VITE_ASSET__DqVZK0OS__"